import { useId } from 'react';

type SiteBriefDesignDirectionPreviewProps = {
  optionIndex: number;
};

// One family of shapes in the brand blues grows bolder from level to level, showing character rather than quality.
export default function SiteBriefDesignDirectionPreview({ optionIndex }: SiteBriefDesignDirectionPreviewProps) {
  const gradient = `${useId().replace(/:/g, '')}-bold`;

  return (
    <svg
      className="sb-design-preview"
      viewBox="0 0 232 94"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="232" height="94" fill="#F3F6FF" />

      {optionIndex === 0 && (
        <>
          <rect x="83" y="26" width="18" height="18" rx="4" fill="#165BFB" />
          <rect x="107" y="26" width="18" height="18" rx="4" fill="#C9DAFF" />
          <rect x="131" y="26" width="18" height="18" rx="4" fill="#C9DAFF" />
          <rect x="83" y="50" width="18" height="18" rx="4" fill="#C9DAFF" />
          <rect x="107" y="50" width="18" height="18" rx="4" fill="#C9DAFF" />
          <rect x="131" y="50" width="18" height="18" rx="4" fill="#C9DAFF" />
        </>
      )}

      {optionIndex === 1 && (
        <>
          <rect x="112" y="20" width="36" height="36" rx="8" fill="#9EBBFF" />
          <circle cx="100" cy="52" r="22" fill="#165BFB" />
          <circle cx="146" cy="68" r="8" fill="#C9DAFF" />
          <rect x="72" y="22" width="12" height="12" rx="3" fill="#DEE8FF" />
        </>
      )}

      {optionIndex === 2 && (
        <>
          <defs>
            <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#165BFB" />
              <stop offset="1" stopColor="#8B5CF6" />
            </linearGradient>
          </defs>
          <path d="M92 30c14-14 40-10 48 6s2 34-16 40-38-2-42-16-4-16 10-30z" fill={`url(#${gradient})`} />
          <rect
            x="112"
            y="16"
            width="44"
            height="44"
            rx="10"
            fill="none"
            stroke="#165BFB"
            strokeWidth="2.5"
            transform="rotate(22 134 38)"
          />
          <circle cx="78" cy="22" r="5" fill="#9EBBFF" />
          <circle cx="158" cy="76" r="4" fill="#165BFB" />
          <rect x="66" y="62" width="14" height="14" rx="3" fill="#C9DAFF" transform="rotate(-18 73 69)" />
          <path d="M160 20l2.2 6.3 6.3 2.2-6.3 2.2-2.2 6.3-2.2-6.3-6.3-2.2 6.3-2.2z" fill="#165BFB" />
        </>
      )}
    </svg>
  );
}
